// src/components/StripePaymentInfo.js
import React from 'react';

function StripePaymentInfo() {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-[1200px] mx-auto p-8 bg-white rounded-lg shadow-lg">
        <h1 className="text-center mb-8 text-4xl font-extrabold text-gray-900">
          Stripeを利用した決済について
        </h1>
        <p className="mb-4 text-gray-700">
          当サービスでは、決済代行として「<strong>Stripe</strong>」を利用しています。以下の事項を必ずご確認ください。
        </p>

        <section className="mb-8">
          <h3 className="mt-4 mb-4 text-2xl font-semibold border-b-2 border-gray-300 pb-2 text-primary">
            1. Stripe 利用規約
          </h3>
          <p className="mb-4 text-gray-700">
            Stripeを通じてクレジットカード決済などを行う場合は、{' '}
            <a
              href="https://stripe.com/jp/legal"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              「Stripe利用規約 — Japan」
            </a>
            をはじめとする関連ドキュメントに同意していただく必要があります。
          </p>
        </section>

        <section className="mb-8">
          <h3 className="mt-4 mb-4 text-2xl font-semibold border-b-2 border-gray-300 pb-2 text-primary">
            2. 禁止・制限付き業種
          </h3>
          <p className="mb-4 text-gray-700">
            Stripeの{' '}
            <a
              href="https://stripe.com/jp/restricted-businesses"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              禁止・制限付き業種
            </a>
            に該当する場合、利用をお断りする可能性があります。ご不明な場合は事前にお問い合わせください。
          </p>
        </section>

        <section className="mb-8">
          <h3 className="mt-4 mb-4 text-2xl font-semibold border-b-2 border-gray-300 pb-2 text-primary">
            3. 支払方法別の規約
          </h3>
          <p className="mb-4 text-gray-700">
            Visa、Mastercard、American Express、JCB、銀行振込、コンビニ決済など、各支払手段には{' '}
            <a
              href="https://stripe.com/payments/payment-methods-guide"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              Stripeの定める利用条件
            </a>
            が適用されます。返金、チャージバック等についても各ブランドの規則に従い処理されます。
          </p>
        </section>

        <section className="mb-8">
          <h3 className="mt-4 mb-4 text-2xl font-semibold border-b-2 border-gray-300 pb-2 text-primary">
            4. プライバシー・セキュリティ
          </h3>
          <p className="mb-4 text-gray-700">
            Stripeの{' '}
            <a
              href="https://stripe.com/jp/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              プライバシーポリシー
            </a>{' '}
            や{' '}
            <a
              href="https://stripe.com/cookies-policy/legal"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              Cookies Policy
            </a>
            等に基づき、カード情報は安全に取り扱われます。当サービスでは、決済情報そのものを直接保持することはありません。
          </p>
        </section>

        <section className="mb-8">
          <h3 className="mt-4 mb-4 text-2xl font-semibold border-b-2 border-gray-300 pb-2 text-primary">
            5. 三井住友カード（SMCC）・JCBとの提携
          </h3>
          <p className="mb-4 text-gray-700">
            日本国内のカード決済は、<strong>三井住友カード</strong>や<strong>JCB</strong>などのアクワイアラとStripeの提携を通じて行われることがあります。これらの追加規約に同意いただく場合があるので、詳しくは{' '}
            <a
              href="https://stripe.com/jp/legal"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              Stripeの公式ページ
            </a>
            をご確認ください。
          </p>
        </section>

        <p className="mb-0 text-sm text-gray-500">
          上記項目は、Stripeによる決済を安全かつ適切に利用するための要点です。詳細・最新情報は{' '}
          <a
            href="https://stripe.com/jp/legal"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            Stripe公式サイト
          </a>
          でご確認ください。
        </p>
      </div>
    </div>
  );
}

export default StripePaymentInfo;
